import {
  PLAY_LIST_SORT_LOCAL_STORAGE_KEY,
  PlayListSortType,
  PLAY_LIST_SORT_LIST,
} from '../../src/features/play_list/components/buttons/PlayListSortButton/constants'

const defaultValue: PlayListSortType = 'by_name'

export const getPlayListSort = (): PlayListSortType => {
  if (typeof window === 'undefined') {
    return defaultValue
  }

  const value = window.localStorage.getItem(
    PLAY_LIST_SORT_LOCAL_STORAGE_KEY,
  ) as PlayListSortType

  if (value && PLAY_LIST_SORT_LIST.includes(value)) {
    return value
  }

  return defaultValue
}

export const setPlayListSort = (sortType: PlayListSortType): void => {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(PLAY_LIST_SORT_LOCAL_STORAGE_KEY, sortType)
  }
}